<div class="calendar-component-container">
  <div
    class="attribute-editor-component"
    rvSpinner="layout-calendar-editor-loader"
    [rvShowSpinner]="spinner"
  >
    <div class="calendar-component-settings te-scrollable-container">
      @if (!calendarType) {
        <div class="attribute-editor-row">
          <div class="row">
            <div class="col-xs-12">
              @if (authenticateFailed) {
                <div class="form-group has-error">
                  <p class="help-block">
                    <span
                      >There was an issue with authentication. Please try
                      again.</span
                    >
                  </p>
                </div>
              }
              <div class="source-container form-group">
                <h3 class="top-heading">Connect your calendar</h3>
                <label
                  >Connect a calendar to display events and room
                  bookings.</label
                >
                <button
                  matButton="outlined"
                  class="tw-w-full tw-mb-[10px] button-role--provider"
                  id="te-layout-calendar-google-connect"
                  type="button"
                  (click)="selectCalendarType(PROVIDER_GOOGLE_CALENDAR)"
                >
                  <mat-icon
                    svgIcon="integration-google"
                    aria-hidden="true"
                  ></mat-icon>
                  <span>Continue with Google</span>
                </button>
                <button
                  matButton="outlined"
                  class="tw-w-full tw-mb-[10px] button-role--provider"
                  id="te-layout-calendar-outlook-connect"
                  type="button"
                  (click)="selectCalendarType(PROVIDER_OUTLOOK_CALENDAR)"
                >
                  <mat-icon
                    svgIcon="integration-microsoft"
                    aria-hidden="true"
                  ></mat-icon>
                  <span>Continue with Microsoft</span>
                </button>
                <rv-divider label="or" />
                <button
                  matButton="outlined"
                  class="tw-w-full button-role--provider"
                  id="te-layout-calendar-enter-url"
                  type="button"
                  (click)="selectCalendarType(CALENDAR_TYPE_PUBLIC)"
                >
                  <mat-icon svgIcon="link" aria-hidden="true"></mat-icon>
                  <span>Enter Public URL</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      } @else {
        <mat-menu
          #connectionOptions="matMenu"
          xPosition="before"
          role="menu"
          tabindex="-1"
        >
          <button
            type="button"
            class="playlist-item-hide"
            tabindex="-1"
            mat-menu-item
            role="menuitem"
            (click)="switchSource()"
          >
            <mat-icon
              svgIcon="switch"
              class="mr-3 small thin"
              aria-hidden="true"
            ></mat-icon>
            <span>Switch Calendar Source</span>
          </button>
          @if (canDisconnect()) {
            <rv-divider class="tw-my-[8px]" />
            <button
              type="button"
              class="playlist-item-hide"
              tabindex="-1"
              mat-menu-item
              role="menuitem"
              (click)="confirmDisconnect()"
            >
              <mat-icon
                svgIcon="unlink"
                class="mr-3 small"
                aria-hidden="true"
              ></mat-icon>
              <span>Disconnect Account</span>
            </button>
          }
        </mat-menu>

        @if (authenticateFailed) {
          <div class="attribute-editor-row">
            <div class="form-group has-error">
              <p class="help-block">
                <span
                  >There was an issue with authentication. Please try
                  again.</span
                >
              </p>
            </div>
          </div>
        }

        @if (revokeFailed) {
          <div class="attribute-editor-row">
            <div class="form-group has-error">
              <p class="help-block">
                We could not revoke your access with
                {{ revokeFailedProviderName }} at this time. We strongly
                recommend you manually revoke access in your
                {{ revokeFailedProviderName }} account.
              </p>
            </div>
          </div>
        }

        @if (USER_AUTHORIZED_PROVIDERS.includes(provider) && componentAccount) {
          <div class="attribute-editor-row tw-mb-[15px]">
            <div class="flex-row flex-wrap space-between mb-3">
              <label>Connected Account</label>
            </div>

            <div class="authenticated button-with-options-menu mt-2">
              <mat-icon
                [svgIcon]="getProviderLogo(provider)"
                aria-hidden="true"
              ></mat-icon>

              <div class="mx-auto u_ellipsis">
                {{ componentAccountUsername || 'account not connected' }}
              </div>

              <button
                class="btn btn-icon"
                aria-label="Options menu"
                type="button"
                [matMenuTriggerFor]="connectionOptions"
              >
                <mat-icon
                  svgIcon="more-vertical"
                  class="tw-rotate-90"
                  aria-hidden="true"
                ></mat-icon>
              </button>
            </div>
          </div>
        }

        @if (
          provider === PROVIDER_GOOGLE_CALENDAR &&
          sameAccount &&
          componentAccountUsername &&
          !isPublicUrl()
        ) {
          <div class="attribute-editor-row">
            <div
              class="form-group has-feedback"
              [ngClass]="{ 'has-error': calendarsFailed }"
            >
              <label id="te-layout-calendar-google-calendar-id-label"
                >Calendar</label
              >
              <multi-select-dropdown
                triggerId="te-layout-calendar-google-calendar-id"
                ariaLabelledBy="te-layout-calendar-google-calendar-id-label te-layout-calendar-google-calendar-id"
                triggerText="Add Calendar"
                [items]="calendarDropdownItems"
                [selectedIds]="selectedCalendarIds"
                [open]="calendarPickerGoogleOpen"
                (openChange)="onGoogleCalendarDropdownOpenChange($event)"
                (selectionToggle)="toggleCalendarSelection($event)"
              ></multi-select-dropdown>
              @if (calendarsFailed) {
                <p class="help-block">
                  <span
                    >We couldn't load your calendars. Try again. If the issue
                    continues, contact support.</span
                  >
                </p>
              }
              <multi-select-pills
                [items]="selectedCalendarPillItems"
                (remove)="toggleCalendarSelection($event)"
                class="mt-2"
              ></multi-select-pills>
            </div>
          </div>
        }

        @if (
          provider === PROVIDER_GOOGLE_CALENDAR &&
          (!sameAccount || !componentAccountUsername) &&
          !isPublicUrl()
        ) {
          <div class="attribute-editor-row">
            <div class="form-group has-feedback">
              <label>Calendar</label><br />
              <multi-select-pills
                [items]="selectedCalendarPillItems"
                (remove)="toggleCalendarSelection($event)"
                class="mt-2"
              ></multi-select-pills>
            </div>
          </div>
        }

        @if (isPublicUrl()) {
          <div class="attribute-editor-row">
            <form>
              <div
                class="form-group has-feedback"
                [ngClass]="{
                  'has-error':
                    calendarUrlStatus && calendarUrlStatus !== 'VALID',
                  'has-success':
                    calendarUrlStatus && calendarUrlStatus === 'VALID',
                }"
              >
                <label for="te-layout-calendar-source">Calendar URL</label>
                <div class="input-with-button-wrapper">
                  <input
                    type="text"
                    id="te-layout-calendar-source"
                    name="te-layout-calendar-source"
                    class="form-control u_ellipsis"
                    placeholder="iCal link or public URL"
                    [(ngModel)]="source"
                    (debounceEvent)="saveCalendarUrl()"
                    aria-label="Calendar URL"
                    maxlength="2048"
                    [attr.aria-invalid]="
                      calendarUrlStatus && calendarUrlStatus !== 'VALID'
                    "
                  />
                  <streamline-icon
                    *ngIf="calendarUrlStatus"
                    class="overlay-icon form-control-feedback"
                    aria-hidden="true"
                    [name]="
                      calendarUrlStatus !== 'VALID'
                        ? 'exclamation'
                        : 'checkmark'
                    "
                    width="14"
                    height="12"
                  ></streamline-icon>
                  <button
                    class="btn btn-icon"
                    aria-label="Options menu"
                    type="button"
                    [matMenuTriggerFor]="connectionOptions"
                    *ngIf="!componentAccount"
                  >
                    <mat-icon
                      svgIcon="more-vertical"
                      class="tw-rotate-90"
                      aria-hidden="true"
                    ></mat-icon>
                  </button>
                </div>

                <p class="help-block">
                  @if (calendarUrlStatus === 'INVALID') {
                    @if (getProviderFromUrl(source) === PROVIDER_ICAL) {
                      <span>
                        This iCal URL is invalid. Please ensure the URL starts
                        with <strong>https://</strong> and ends with
                        <strong>.ics</strong>.
                      </span>
                    } @else {
                      <span>
                        This calendar is invalid or not publicly accessible. To
                        fix the issue, see
                        <a
                          href="https://help.risevision.com/hc/en-us/articles/48407811260948-Show-a-Google-or-Microsoft-Calendar"
                          target="_blank"
                          rel="noopener noreferrer"
                          >this article</a
                        >.</span
                      >
                    }
                  }
                  @if (calendarUrlStatus === 'FAILED') {
                    <span>
                      Could not retrieve information for calendar {{ source }}.
                      Please try again. If you need help email
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="mailto:support@risevision.com"
                        >support&#64;risevision.com</a
                      ></span
                    >
                  }
                </p>
              </div>
            </form>
            @if (
              source &&
              calendarUrlStatus === 'VALID' &&
              provider === PROVIDER_GOOGLE_CALENDAR
            ) {
              <div>
                <a
                  [href]="googleCalendarLink()"
                  target="_blank"
                  rel="noopener noreferrer"
                  >View Calendar</a
                >
              </div>
            }
          </div>
        }

        @if (
          provider === PROVIDER_OUTLOOK_CALENDAR &&
          sameAccount &&
          componentAccountUsername &&
          !isPublicUrl()
        ) {
          <div class="attribute-editor-row">
            <div
              class="form-group has-feedback"
              [ngClass]="{ 'has-error': outlookGroupsFailed }"
            >
              <label>Calendar Group</label>
              <select
                class="form-control"
                id="te-layout-calendar-outlook-group-id"
                name="te-layout-calendar-outlook-group-id"
                [(ngModel)]="selectedOutlookGroup"
                (ngModelChange)="selectedOutlookGroupChanged()"
              >
                <option value="" [shown]="false">Select Group</option>
                @for (g of outlookGroups; track g.id) {
                  <option [value]="g.id">{{ g.name }}</option>
                }
              </select>
              @if (outlookGroupsFailed) {
                <p class="help-block">
                  <span
                    >We couldn't load your Outlook calendar groups. Try again.
                    If the issue continues, contact support.</span
                  >
                </p>
              }
            </div>
          </div>
          <div class="attribute-editor-row">
            <div
              class="form-group has-feedback"
              [ngClass]="{ 'has-error': calendarsFailed }"
            >
              <label id="te-layout-calendar-outlook-calendar-id-label"
                >Calendar</label
              >
              <multi-select-dropdown
                triggerId="te-layout-calendar-outlook-calendar-id"
                ariaLabelledBy="te-layout-calendar-outlook-calendar-id-label te-layout-calendar-outlook-calendar-id"
                triggerText="Add Calendar"
                [items]="calendarDropdownItems"
                [selectedIds]="selectedCalendarIds"
                [open]="calendarPickerOutlookOpen"
                (openChange)="onOutlookCalendarDropdownOpenChange($event)"
                (selectionToggle)="toggleCalendarSelection($event)"
              ></multi-select-dropdown>
              @if (calendarsFailed) {
                <p class="help-block">
                  <span
                    >We couldn't load your calendars. Try again. If the issue
                    continues, contact support.</span
                  >
                </p>
              }
              <multi-select-pills
                [items]="selectedCalendarPillItems"
                (remove)="toggleCalendarSelection($event)"
                class="mt-2"
              ></multi-select-pills>
            </div>
          </div>
        }

        @if (
          provider === PROVIDER_OUTLOOK_CALENDAR &&
          (!sameAccount || !componentAccountUsername) &&
          !isPublicUrl()
        ) {
          <div class="attribute-editor-row">
            <div class="form-group has-feedback">
              <label>Calendar</label><br />
              <multi-select-pills
                [items]="selectedCalendarPillItems"
                (remove)="toggleCalendarSelection($event)"
                class="mt-2"
              ></multi-select-pills>
            </div>
          </div>
        }

        <!-- Layout Selection -->
        <div class="attribute-editor-row">
          <label id="layout-calendar-layout-label">Layout</label>
          <div class="form-group layout-selector">
            <div
              class="layout-container"
              role="radiogroup"
              aria-labelledby="layout-calendar-layout-label"
            >
              <button
                type="button"
                class="layout-option"
                [ngClass]="{
                  'layout-option--selected': layout === LayoutType.SCROLLING,
                }"
                (click)="setLayout(LayoutType.SCROLLING)"
                [attr.aria-checked]="layout === LayoutType.SCROLLING"
                role="radio"
              >
                <div class="layout-icon-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="54"
                    height="55"
                    viewBox="0 0 54 55"
                    fill="none"
                  >
                    <rect
                      opacity="0.2"
                      y="16"
                      width="54"
                      height="13"
                      rx="2"
                      fill="#8D94A1"
                    />
                    <rect
                      opacity="0.5"
                      x="1.66602"
                      y="18"
                      width="12"
                      height="3"
                      rx="1.33333"
                      fill="#8D94A1"
                    />
                    <rect
                      opacity="0.5"
                      x="1.66602"
                      y="34"
                      width="12"
                      height="3"
                      rx="1.33333"
                      fill="#8D94A1"
                    />
                    <rect
                      opacity="0.2"
                      width="54"
                      height="13"
                      rx="2"
                      fill="#8D94A1"
                    />
                    <rect
                      opacity="0.5"
                      x="1.66602"
                      y="2"
                      width="12"
                      height="3"
                      rx="1.33333"
                      fill="#8D94A1"
                    />
                    <rect
                      opacity="0.2"
                      y="32"
                      width="54"
                      height="13"
                      rx="2"
                      fill="#8D94A1"
                    />
                    <mask
                      id="path-7-outside-1_6598_1678"
                      maskUnits="userSpaceOnUse"
                      x="16"
                      y="25"
                      width="22"
                      height="31"
                      fill="black"
                    >
                      <rect fill="white" x="16" y="25" width="22" height="31" />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M31.2939 27C31.5701 27 31.7939 27.2239 31.7939 27.5V43.5H35.0869C35.5322 43.5001 35.7553 44.0386 35.4404 44.3535L27.2939 52.5L19.1475 44.3535C18.8325 44.0385 19.0555 43.5 19.501 43.5H22.7939V27.5C22.7939 27.2239 23.0178 27 23.2939 27H31.2939Z"
                      />
                    </mask>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M31.2939 27C31.5701 27 31.7939 27.2239 31.7939 27.5V43.5H35.0869C35.5322 43.5001 35.7553 44.0386 35.4404 44.3535L27.2939 52.5L19.1475 44.3535C18.8325 44.0385 19.0555 43.5 19.501 43.5H22.7939V27.5C22.7939 27.2239 23.0178 27 23.2939 27H31.2939Z"
                      fill="#8D94A1"
                    />
                    <path
                      d="M31.2939 27L31.294 25H31.2939V27ZM31.7939 27.5L33.7939 27.5L31.7939 27.5ZM31.7939 43.5H29.7939V45.5H31.7939V43.5ZM35.0869 43.5L35.0875 41.5H35.0869V43.5ZM35.4404 44.3535L36.8546 45.7677L36.8549 45.7675L35.4404 44.3535ZM27.2939 52.5L25.8797 53.9142L27.2939 55.3284L28.7082 53.9142L27.2939 52.5ZM19.1475 44.3535L20.5617 42.9393L19.1475 44.3535ZM19.501 43.5V41.5H19.501L19.501 43.5ZM22.7939 43.5V45.5H24.7939V43.5H22.7939ZM22.7939 27.5L20.7939 27.5V27.5H22.7939ZM31.2939 27L31.2939 29C30.4655 29 29.7939 28.3285 29.7939 27.5L31.7939 27.5L33.7939 27.5C33.7939 26.1193 32.6746 25 31.294 25L31.2939 27ZM31.7939 27.5H29.7939V43.5H31.7939H33.7939V27.5H31.7939ZM31.7939 43.5V45.5H35.0869V43.5V41.5H31.7939V43.5ZM35.0869 43.5L35.0864 45.5C33.7505 45.4996 33.0812 43.8846 34.0259 42.9396L35.4404 44.3535L36.8549 45.7675C38.4293 44.1925 37.3139 41.5006 35.0875 41.5L35.0869 43.5ZM35.4404 44.3535L34.0262 42.9393L25.8797 51.0858L27.2939 52.5L28.7082 53.9142L36.8546 45.7677L35.4404 44.3535ZM27.2939 52.5L28.7082 51.0858L20.5617 42.9393L19.1475 44.3535L17.7332 45.7677L25.8797 53.9142L27.2939 52.5ZM19.1475 44.3535L20.5617 42.9393C21.5065 43.8841 20.8375 45.5 19.501 45.5L19.501 43.5L19.501 41.5C17.2735 41.5 16.1585 44.1929 17.7332 45.7677L19.1475 44.3535ZM19.501 43.5V45.5H22.7939V43.5V41.5H19.501V43.5ZM22.7939 43.5H24.7939V27.5H22.7939H20.7939V43.5H22.7939ZM22.7939 27.5L24.7939 27.5C24.7939 28.3284 24.1224 29 23.2939 29V27V25C21.9132 25 20.7939 26.1193 20.7939 27.5L22.7939 27.5ZM23.2939 27V29H31.2939V27V25H23.2939V27Z"
                      fill="white"
                      mask="url(#path-7-outside-1_6598_1678)"
                    />
                  </svg>
                </div>
                <div class="layout-label">Scrolling</div>
              </button>
              <button
                type="button"
                class="layout-option"
                [ngClass]="{
                  'layout-option--selected': layout === LayoutType.SINGLE,
                }"
                (click)="setLayout(LayoutType.SINGLE)"
                [attr.aria-checked]="layout === LayoutType.SINGLE"
                role="radio"
              >
                <div class="layout-icon-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="24"
                    viewBox="0 0 64 24"
                    fill="none"
                  >
                    <rect
                      opacity="0.2"
                      width="64"
                      height="24"
                      rx="2"
                      fill="#8D94A1"
                    />
                    <rect
                      x="23"
                      y="4"
                      width="11"
                      height="3"
                      rx="1.33333"
                      fill="#8D94A1"
                    />
                    <rect
                      opacity="0.5"
                      x="23"
                      y="9"
                      width="31"
                      height="3"
                      rx="1.33333"
                      fill="#8D94A1"
                    />
                    <rect
                      x="3"
                      y="3"
                      width="16"
                      height="18"
                      rx="1.33333"
                      fill="white"
                    />
                    <path
                      d="M8.08108 16V14.6474L11.0365 11.7211C11.2878 11.461 11.4986 11.2269 11.6689 11.0188C11.8419 10.8107 11.973 10.6069 12.0622 10.4075C12.1514 10.2052 12.1959 9.98699 12.1959 9.75289C12.1959 9.49277 12.1405 9.26879 12.0297 9.08092C11.9189 8.89017 11.7676 8.74422 11.5757 8.64306C11.3838 8.53902 11.1662 8.48699 10.923 8.48699C10.6689 8.48699 10.4473 8.54191 10.2581 8.65173C10.0689 8.76156 9.92297 8.91908 9.82027 9.12428C9.71757 9.32948 9.66622 9.5737 9.66622 9.85694H8C8 9.27601 8.12297 8.77168 8.36892 8.34393C8.61486 7.91619 8.95946 7.58526 9.4027 7.35116C9.84595 7.11705 10.3568 7 10.9351 7C11.5297 7 12.0473 7.11272 12.4878 7.33815C12.9311 7.56069 13.2757 7.86994 13.5216 8.2659C13.7676 8.66185 13.8905 9.11561 13.8905 9.62717C13.8905 9.96243 13.8284 10.2934 13.7041 10.6199C13.5824 10.9465 13.3649 11.3092 13.0514 11.7081C12.7378 12.104 12.2959 12.5795 11.7257 13.1344L10.5135 14.4046V14.4653H14V16H8.08108Z"
                      fill="#8D94A1"
                    />
                  </svg>
                </div>
                <div class="layout-label">Single Event</div>
              </button>
              <button
                *requireRole="AI_LAYOUT_ROLE"
                type="button"
                class="layout-option"
                [ngClass]="{
                  'layout-option--selected': isCustomLayout,
                }"
                (click)="openLayoutAi()"
                [attr.aria-checked]="isCustomLayout"
                role="radio"
              >
                <div class="layout-icon-container">
                  <mat-icon svgIcon="ai-gradient" aria-hidden="true"></mat-icon>
                </div>
                <div class="layout-label">AI layout</div>
              </button>
            </div>
          </div>
        </div>

        <div class="attribute-editor-row">
          <label>Date Range</label>
          <div
            class="has-feedback"
            [ngClass]="{
              'has-error': !isValidRange(),
              'has-success': isValidRange() && range,
            }"
          >
            <div class="flex-row">
              <input
                type="number"
                class="form-control mr-2"
                id="te-layout-calendar-range"
                name="te-layout-calendar-range"
                placeholder="Range"
                [(ngModel)]="range"
                [min]="rangeMin"
                [max]="rangeMax"
                (ngModelChange)="rangeChanged()"
                aria-label="Date range value"
              />
              <select
                class="form-control"
                id="te-layout-calendar-period"
                name="te-layout-calendar-period"
                [(ngModel)]="period"
                (ngModelChange)="periodChanged()"
                aria-label="Date range period"
              >
                <option value="days">Days</option>
                <option value="weeks">Weeks</option>
                <option value="months">Months</option>
              </select>
            </div>
            @if (!isValidRange()) {
              <p class="help-block">
                <span
                  >Please provide a number between {{ rangeMin }} and
                  {{ rangeMax }}.</span
                >
              </p>
            }
          </div>
        </div>
        @if (
          isCustomLayout
            ? usesAttribute('slideDuration')
            : layout === LayoutType.SINGLE
        ) {
          <div class="attribute-editor-row">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label>Slide Duration</label>
                  <div class="input-group">
                    <input
                      type="number"
                      id="te-layout-calendar-slide-duration"
                      class="form-control"
                      [(ngModel)]="slideDuration"
                      (change)="saveSlideDuration()"
                    />
                    <span class="input-group-addon">Seconds</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <div
          class="attribute-editor-row"
          [shown]="usesAttribute('showDescription')"
        >
          <div class="flex-row left-right-aligner pt-3 form-group">
            <label
              id="layout-calendar-show-description-label"
              class="mb-0 control-label"
              >Show Description</label
            >
            <mat-slide-toggle
              class="pl-3"
              [checked]="showDescription"
              (change)="showDescription = $event.checked; save()"
              [attr.aria-labelledby]="'layout-calendar-show-description-label'"
            ></mat-slide-toggle>
          </div>
        </div>
        <div
          class="attribute-editor-row"
          [shown]="usesAttribute('showLocation')"
        >
          <div class="flex-row left-right-aligner pt-3 form-group">
            <label
              id="layout-calendar-show-location-label"
              class="mb-0 control-label"
              >Show Location</label
            >
            <mat-slide-toggle
              class="pl-3"
              [checked]="showLocation"
              (change)="showLocation = $event.checked; save()"
              [attr.aria-labelledby]="'layout-calendar-show-location-label'"
            ></mat-slide-toggle>
          </div>
        </div>
        <div class="attribute-editor-row">
          <div class="flex-row left-right-aligner pt-3">
            <label
              for="te-layout-calendar-completed"
              id="layout-calendar-completed-label"
              class="mb-0 control-label"
              >Show Completed Events</label
            >
            <mat-slide-toggle
              id="te-layout-calendar-completed"
              class="pl-3"
              [checked]="showCompleted"
              (change)="showCompleted = $event.checked; save()"
              ariaLabelledby="layout-calendar-completed-label"
            ></mat-slide-toggle>
          </div>
        </div>

        <div
          class="attribute-editor-row tw-mt-[20px]"
          [shown]="usesAttribute('color')"
        >
          <div class="form-group">
            <label for="te-layout-calendar-color">Color</label>
            <div class="flex-row left-right-aligner">
              <color-picker
                pickerId="te-layout-calendar-color"
                [(ngModel)]="color"
                (change)="save()"
                ngDefaultControl
              ></color-picker>
            </div>
          </div>
        </div>

        <div
          class="attribute-editor-row"
          [shown]="usesAttribute('backgroundColor')"
        >
          <div class="form-group">
            <label for="te-layout-calendar-bg-color">Background</label>
            <div class="flex-row left-right-aligner">
              <color-picker
                pickerId="te-layout-calendar-bg-color"
                [(ngModel)]="backgroundColor"
                (change)="save()"
                ngDefaultControl
              ></color-picker>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
